import React from 'react';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import FooterOne from '../../common/footer/FooterOne';
import Banner from '../../components/solutions/manufacturing/Banner';
import AISolutions from '../../components/solutions/manufacturing/AISolutions';
import CaseStudy from '../../components/solutions/manufacturing/CaseStudy';
import ManufacturingTransformation from '../../components/solutions/manufacturing/ManufacturingTransformation';
import Advantage from '../../components/solutions/manufacturing/Advantage';
import FooterBanner from '../../components/solutions/manufacturing/FooterBanner';

const Manufacturing = () => {

  return (
    <>
      <SEO
				title="Manufacturing Industry Solutions"
				description="Powering Smarter, Sustainable, and Resilient Manufacturing Through AI & Edge Intelligence"
      />
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <Banner />
      <AISolutions />
      <CaseStudy />
      <ManufacturingTransformation />
      <Advantage />
      <FooterBanner />
      <FooterOne />
    </>
  )
}

export default Manufacturing;